module.exports = __webpack_public_path__ + "img/1.ac5970a2.png";